<template>
  <div class="flex flex-col items-center py-20 gap-y-16">
    <div class="flex gap-x-4">
      <NuxtImg width="46px" height="45px" src="/icons/heartbeat.svg"></NuxtImg>
      <div class="flex flex-col">
        <span class="font-semibold"> {{ subTitle }}</span>
        <h2>{{ parentCategory.title }}</h2>
      </div>
    </div>
    <div class="w-full grid md:grid-cols-2 md:gap-x-32 md:px-12">
      <div
        v-for="(subCategory, index) in subCategories"
        :key="index"
        class="flex border-y p-5 items-center"
      >
        <NuxtLinkLocale
          :locale="switchBlogLocale()"
          :to="`/tests/health-and-wellness/${subCategory.slug}`"
        >
          <h3 class="text-blog-18 font-bold">{{ subCategory.title }}</h3>
        </NuxtLinkLocale>
        <NuxtImg
          loading="lazy"
          src="/icons/arrow-right-black.svg"
          alt="checkmark"
          class="ml-auto w-2.5 h-2 colorize-blue"
          width="10"
          height="8"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  parentCategory: {
    type: Object,
  },
  subTitle: {
    type: String,
  },
});
const subCategories = ref();
subCategories.value = await useFetchSubCategoryLists(props.parentCategory.slug);
</script>
